import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import LinksComponent from "../../../../components/Tenant/LinksComponent/LinksComponent";
import ZoneMasterList from "../ZoneMaster/ZoneMasterList";
import StateMasterList from "../StateMaster/StateMasterList";
import DistrictMasterList from "../DistrictMaster/DistrictMasterList";
import BranchList from "../Branch/BranchList";
import CityMasterList from "../CityMaster/CityMasterList";

const TABS = [
  { key: "zone", label: "Zone", Component: ZoneMasterList },
  { key: "state", label: "State", Component: StateMasterList },
  { key: "district", label: "District", Component: DistrictMasterList },
  { key: "branch", label: "Branch", Component: BranchList },
  { key: "city", label: "City", Component: CityMasterList },
];
const TAB_KEYS = TABS.map((tab) => tab.key);

const LocationMaster = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = TAB_KEYS.includes(searchParams.get("tab")) ? searchParams.get("tab") : "zone";
  const [activeTab, setActiveTab] = useState(initialTab);

  const selectTab = (key) => {
    setActiveTab(key);
    setSearchParams({ tab: key }, { replace: true });
  };

  const ActiveComponent = TABS.find((tab) => tab.key === activeTab)?.Component || ZoneMasterList;

  return (
    <div className="flex w-full bg-gray-200 h-full justify-center">
      <div className="w-full">
        <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
          Location Master
          <LinksComponent />
        </div>

        <div className="px-3 pt-3 bg-white">
          <div className="flex gap-2 border-b">
            {TABS.map(({ key, label }) => (
              <button
                key={key}
                type="button"
                className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px ${
                  activeTab === key
                    ? "border-blue-600 text-blue-700"
                    : "border-transparent text-gray-500 hover:text-gray-700"
                }`}
                onClick={() => selectTab(key)}
              >
                {label}
              </button>
            ))}
          </div>
        </div>

        <ActiveComponent embedded />
      </div>
    </div>
  );
};

export default LocationMaster;
